import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Wrapper = styled.div`
  ${({ grids }) => css`
    display: grid;
    height: 100%;

    grid-template-columns: minmax(70%, max-content) minmax(30%, min-content) 100%;
    gap: 0.5rem;
    @media (max-width: 425px) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;
